import * as React from 'react';
import { ProgressBarWrapper, ProgressBar, ProgressBarPoint } from '../../ui/ProgressBar';
import moment from 'moment';
import { IF } from '../../hoc/If';
import I18n from '../../../core/localization/I18n';

export interface ITimelineProps {
    startDate: Date,
    initialEndDate: Date,
    actualEndDate: Date,
}

const TooltipContent = ({title, date}) => {
    return(
        <>
            <div className="timeline__tooltip-title">
                {I18n.t(`${title}`)}
            </div>
            <div className="timeline__tooltip-subtitle">
                <IF condition={!date}>{I18n.t("table.noInput")}</IF>
                <IF condition={date}>{moment(date).format("L")}</IF>
            </div>
        </>
    )
}

export const Timeline: React.FunctionComponent<ITimelineProps> = (props) => {
    let totalDaysDiff: number
    let todayPosition;
    let actualEndDatePosition;
    
    const isTodayLastDate = moment(new Date()).isAfter(props.actualEndDate)

    if (isTodayLastDate) {
        totalDaysDiff = moment(new Date()).diff(moment(props.startDate), 'days');
        const actualEndDateDiff = totalDaysDiff - moment(new Date()).diff(moment(props.actualEndDate), 'days');
        actualEndDatePosition = actualEndDateDiff * 100 / totalDaysDiff;;
        todayPosition = 100;
    } else {
        totalDaysDiff = moment(props.actualEndDate).diff(moment(props.startDate), 'days');
        const todayDiff = totalDaysDiff - moment(props.actualEndDate).diff(moment(new Date()), 'days');
        todayPosition = todayDiff * 100 / totalDaysDiff;
        actualEndDatePosition = 100
    }

    const initialEndDateDiff = totalDaysDiff - (isTodayLastDate ? moment(new Date()) : moment(props.actualEndDate)).diff(moment(props.initialEndDate), 'days');
    const initialEndDatePosition = initialEndDateDiff * 100 / totalDaysDiff;

    return (
    <ProgressBarWrapper>
        <IF condition={moment(props.initialEndDate).isSame(props.actualEndDate)}>
            <ProgressBar
                width={isTodayLastDate ? actualEndDatePosition : todayPosition}
            />
            <IF condition={isTodayLastDate}>
                <ProgressBar
                    width={todayPosition - actualEndDatePosition}
                    offset={actualEndDatePosition}
                    type={"primary-danger"}
                />
            </IF>
        </IF>
        <IF condition={!moment(props.initialEndDate).isSame(props.actualEndDate)}>
            <ProgressBar
                width={initialEndDatePosition}
            />
            <IF condition={isTodayLastDate}>
                <ProgressBar
                    width={actualEndDatePosition - initialEndDatePosition}
                    offset={initialEndDatePosition}
                    type={"primary-warning"}
                />
                <ProgressBar
                    width={todayPosition - actualEndDatePosition}
                    offset={actualEndDatePosition}
                    type={"primary-danger"}
                />
            </IF>
            <IF condition={!isTodayLastDate}>
                <ProgressBar
                    width={todayPosition - initialEndDatePosition}
                    offset={initialEndDatePosition}
                    type={"primary-warning"}
                />
            </IF>
        </IF>


        {/* TODAY DATE */}
        <IF condition={moment(new Date()).isAfter(props.startDate)}>
            <ProgressBarPoint
                shape="line"
                type={isTodayLastDate ? "primary-danger" : !moment(props.initialEndDate).isSame(props.actualEndDate) ? "primary-warning" : "primary"}
                offset={todayPosition}
                tooltipPosition={isTodayLastDate ? "bottom-right" : "bottom"}
                tooltipContent={<>
                    <div className="timeline__tooltip-title">
                        {I18n.t("phrases.today")}
                    </div>
                    <div className="timeline__tooltip-subtitle">
                        {moment(new Date()).format("L")}
                    </div>
                </>
                } />
        </IF>

        {/* START DATE */}
        <ProgressBarPoint
            // shape={moment(new Date()).isAfter(props.startDate)? "circle" : "empty-circle"}
            shape={"empty-circle"}
            offset={0}
            tooltipPosition="bottom-left"
            className="progress-bar__point--first"
            tooltipContent={<TooltipContent date={props.startDate} title="phrases.startDate" />}
        />

        {/* INITIAL END DATE */}
        <IF condition={!moment(props.initialEndDate).isSame(props.actualEndDate)}>
            <ProgressBarPoint
                shape="empty-circle"
                offset={initialEndDatePosition}
                tooltipContent={<TooltipContent date={props.initialEndDate} title="phrases.initialTargetDeliveryDate" />} 
            />
        </IF>

        {/* ACTUAL END DATE */}
        <ProgressBarPoint
            shape="empty-circle"
            type={isTodayLastDate ? "primary-danger" : "default"}
            className="progress-bar__point--last"
            tooltipPosition={isTodayLastDate ? "bottom" : "bottom-right"}
            offset={actualEndDatePosition}
            tooltipContent={
                <TooltipContent 
                    date={props.actualEndDate} 
                    title={
                        moment(props.initialEndDate)
                        .isSame(props.actualEndDate) ?
                            "phrases.targetDeliveryDate"
                        : 
                            "phrases.newTargetDeliveryDate"
                        }
                />
            }
        />
    </ProgressBarWrapper>
    )
};